import React, { useState } from 'react';
import { Button } from './Button';
import { Star, ShoppingCart, Check, Heart, Eye } from 'lucide-react';
export const BestSellers = () => {
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [addedToCart, setAddedToCart] = useState({});
  const [favorites, setFavorites] = useState({});
  const bestSellers = [{
    id: 1,
    name: 'Holographic Galaxy',
    price: '$3.99',
    rating: 4.9,
    reviews: 124,
    image: 'https://images.unsplash.com/photo-1508896694512-1eade558679c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80'
  }, {
    id: 2,
    name: 'Retro Waves',
    price: '$2.99',
    rating: 4.7,
    reviews: 98,
    image: 'https://images.unsplash.com/photo-1607799279861-4dd421887fb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80'
  }, {
    id: 3,
    name: 'Cute Animals Pack',
    price: '$4.99',
    rating: 5.0,
    reviews: 156,
    image: 'https://images.unsplash.com/photo-1612404819070-77c0da6b6d4a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80'
  }, {
    id: 4,
    name: 'Plant Lovers',
    price: '$3.49',
    rating: 4.8,
    reviews: 87,
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80'
  }];
  const handleAddToCart = productId => {
    setAddedToCart(prev => ({
      ...prev,
      [productId]: true
    }));
    // Reset after animation
    setTimeout(() => {
      setAddedToCart(prev => ({
        ...prev,
        [productId]: false
      }));
    }, 2000);
  };
  const toggleFavorite = productId => {
    setFavorites(prev => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };
  return <section id="shop" className="bg-gray-50 py-16 scroll-mt-20" data-id="element-8">
      <div className="container mx-auto px-4" data-id="element-9">
        <div className="text-center mb-12" data-id="element-10">
          <span className="text-[#ff6b6b] font-medium" data-id="element-11">Top Picks</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2 mb-4" data-id="element-12">
            Our Best Sellers
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-13">
            Check out our most popular sticker designs loved by customers
            worldwide.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-14">
          {bestSellers.map(product => <div key={product.id} className="bg-white rounded-xl overflow-hidden shadow-lg transform transition-all duration-500 hover:-translate-y-2 hover:shadow-xl" onMouseEnter={() => setHoveredProduct(product.id)} onMouseLeave={() => setHoveredProduct(null)} data-id="element-15">
              <div className="relative h-48 overflow-hidden group" data-id="element-16">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-17" />
                <div className="absolute top-0 right-0 bg-[#ffcc29] text-gray-800 font-medium px-3 py-1 rounded-bl-lg" data-id="element-18">
                  Best Seller
                </div>
                {/* Quick Action Buttons */}
                <div className={`absolute top-2 left-2 transition-opacity duration-300 ${hoveredProduct === product.id ? 'opacity-100' : 'opacity-0'}`} data-id="element-19">
                  <button onClick={() => toggleFavorite(product.id)} className={`p-2 rounded-full ${favorites[product.id] ? 'bg-[#ff6b6b] text-white' : 'bg-white text-gray-700'} shadow-md hover:transform hover:scale-110 transition-all`} data-id="element-20">
                    <Heart className={`h-4 w-4 ${favorites[product.id] ? 'fill-white' : ''}`} data-id="element-21" />
                  </button>
                </div>
                {/* Quick View Button */}
                <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${hoveredProduct === product.id ? 'opacity-100' : 'opacity-0'}`} data-id="element-22">
                  <button className="bg-white bg-opacity-80 text-gray-800 px-4 py-2 rounded-full shadow-lg hover:bg-opacity-100 transition-all transform hover:scale-105 flex items-center" data-id="element-23">
                    <Eye className="h-4 w-4 mr-1" data-id="element-24" />
                    Quick View
                  </button>
                </div>
              </div>
              <div className="p-5" data-id="element-25">
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-26">
                  {product.name}
                </h3>
                <div className="flex items-center mb-3" data-id="element-27">
                  <div className="flex items-center" data-id="element-28">
                    <Star className="h-4 w-4 text-[#ffcc29] fill-[#ffcc29]" data-id="element-29" />
                    <span className="text-gray-700 ml-1 font-medium" data-id="element-30">
                      {product.rating}
                    </span>
                  </div>
                  <span className="text-gray-500 text-sm ml-2" data-id="element-31">
                    ({product.reviews} reviews)
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-32">
                  <span className="text-[#00b8c4] font-bold text-xl" data-id="element-33">
                    {product.price}
                  </span>
                  <Button primary={false} size="small" className={`flex items-center gap-2 transition-all duration-300 ${addedToCart[product.id] ? 'bg-green-500 text-white' : ''}`} onClick={() => handleAddToCart(product.id)} data-id="element-34">
                    {addedToCart[product.id] ? <>
                        <Check className="h-4 w-4" data-id="element-35" />
                        Added
                      </> : <>
                        <ShoppingCart className="h-4 w-4" data-id="element-36" />
                        Add to Cart
                      </>}
                  </Button>
                </div>
              </div>
            </div>)}
        </div>
        <div className="text-center mt-12" data-id="element-37">
          <Button primary={false} size="large" className="animate-bounce" data-id="element-38">
            Shop Now
          </Button>
        </div>
      </div>
    </section>;
};